import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";
import { CommentListItem, CommentText } from "../comments-view/comments-view.styles";
import { makeKey } from "../../../../utils/helpers";
import ListItemText from "@material-ui/core/ListItemText";
import React from "react";
import { CommentsListProps } from "./comments-list.props";
import { IComment } from "../../types/icomment.interface";
import { LineBreaks } from "../../../../components/line-breaks/line-breaks.component";
import { CommentsListAvatar } from "../comments-list-avatar/comments-list-avatar.component";
import { CommentsListName } from "../comments-list-name/comments-list-name.component";
import { CommentsListDate } from "../comments-list-date/comments-list-date.component";

export const CommentsList = withShowIf((props: CommentsListProps) => {
  if (!props.comments?.results) {
    return null;
  }

  return (
    <>
      {props.comments.results.map((comment: IComment) => (
        <CommentListItem id={makeKey("comment", comment.id)} key={makeKey("comment", comment.id)}>
          <CommentsListAvatar user={comment.user} />
          <ListItemText>
            <CommentsListName currentUser={props.user} comment={comment} />
            <CommentsListDate comment={comment} />
            <CommentText>
              <LineBreaks text={comment.content} />
            </CommentText>
          </ListItemText>
        </CommentListItem>
      ))}
    </>
  );
});
